import Dexie from 'dexie';

//
// Declare Dexie Database
//
export class CallbackDatabase extends Dexie {
    callbacks: Dexie.Table<{ id: string, value: string }, string>;

    constructor() {
        super("jira_for_outlook");
        this.version(1).stores({
            callbacks: "id"
        });
    }
}

export interface CallMethodParameters {
    methodName: string;
    args: any[];
}

export abstract class DialogMessenger {
    abstract setData(key: string, message: string);
    abstract getData(key: string): Promise<string>;
    abstract callAsyncMethod(message: CallMethodParameters, cbk?: (data) => void);
    abstract getName(): string;
    abstract cleanup();
}
